import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

interface LicenseUpdateDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  companyName: string
  isActivating: boolean
}

export function LicenseUpdateDialog({
  isOpen,
  onClose,
  onConfirm,
  companyName,
  isActivating,
}: LicenseUpdateDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {isActivating ? "Lisansı Aktifleştir" : "Lisansı Durdur"}
          </DialogTitle>
          <DialogDescription>
            {isActivating ? (
              <>
                <p><strong>{companyName}</strong> firmasının lisansını aktifleştirmek üzeresiniz.</p>
                <p className="mt-2">Bu işlem:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Firmanın tüm hizmetlere erişimini açar</li>
                  <li>Yöneticilerin panele girişini aktifleştirir</li>
                  <li>Müzik sistemlerinin çalışmasını sağlar</li>
                </ul>
              </>
            ) : (
              <>
                <p><strong>{companyName}</strong> firmasının lisansını durdurmak üzeresiniz.</p>
                <p className="mt-2">Bu işlem:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Firmanın tüm hizmetlere erişimini durdurur</li>
                  <li>Yöneticilerin panele girişini engeller</li>
                  <li>Müzik sistemlerinin çalışmasını durdurur</li>
                </ul>
                <p className="mt-4 text-destructive">
                  Bu işlem geri alınabilir ancak firma hizmetleri kullanamayacağı için dikkatli olun!
                </p>
              </>
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            İptal
          </Button>
          <Button
            variant={isActivating ? "default" : "destructive"}
            onClick={() => {
              onConfirm()
              onClose()
            }}
          >
            {isActivating ? "Aktifleştir" : "Durdur"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
